import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      float: "left",
      listStyleType: "none",
      padding: 0,
      margin: 0,
      overflow: "hidden",

      "& li": {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",

        float: "left",
        fontSize: 12,
        marginBottom: 2,
        marginLeft: theme.spacing(2),
        fontWeight: theme.typography.fontWeightMedium,
        cursor: "pointer",

        "&:hover": {
          textDecoration: "underline",
        },

        "&.current": {
          fontSize: 12,
          fontWeight: theme.typography.fontWeightBold,
        },
      },
    },
  }),
  {
    name: "language-chooser-style",
    flip: null,
  }
);
